<template>
	<div>
		<h1>{{title}}</h1>
		<div class="body" v-html="text"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				title : '隐私政策',
				name: '',
				text : ''
			}
		},
		created() {
			let that = this;
			var  query = this.$route.query;
			that.name  = query.name ? query.name : 'yinshi' ;
			that.title = that.name == 'yinshi' ? '隐私政策' : '服务协议';
			that.$http('get','/api/v1/config?name='+that.name) .then(function (res) {
				that.text = res.data;
			});	
		},
	}
</script>

<style>
	h1 {
		text-align: center;
		padding-top: 10px;
		padding-bottom: 10px;
	}
	.body {
		width: 1200px;
		margin: auto;
	}
</style>
